import { render } from "./fushun.vue?vue&type=template&id=2772441a&scoped=true"
import script from "./fushun.vue?vue&type=script&lang=js"
export * from "./fushun.vue?vue&type=script&lang=js"

import "./fushun.vue?vue&type=style&index=0&id=2772441a&lang=scss&scoped=true"

import exportComponent from "C:\\xiangmu\\gas-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2772441a"]])

export default __exports__